﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_banco_id: new EntityColumn<string>({ name: 'c_banco_id', type: 'char', length: 20, flags: c.PK, prompt: 'Banco Id' }),
        vc_banco_nombre: new EntityColumn<string>({ name: 'vc_banco_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Banco Nombre' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        banc_brwStandard: { name: 'banc_brwStandard', keyMappings: { c_banco_id: 0 } }
    }
)


export class BancosDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('Bancos');
    }
}